var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PriorApproval',{attrs:{"ServiceID":_vm.AppServiceID}})
}
var staticRenderFns = []

export { render, staticRenderFns }